import Vue from "vue";
import vueFilters from "./vue-filters";
import { getCustomCart, removeItem, setQuantity, addToCart } from "./request";
import { deepClone, updateCount } from "./helpers";
// import updateCartBadge from "./update-badge-count";

let cartHovers = Array.from(document.querySelectorAll(".cart-hover"));
let cartIsOpen = false;
let scrollY = getScrollY();
let scrollX = getScrollX();
let cartOffset = {
    top: 20,
    right: 30,
};

function initCartApp() {
    var el = document.querySelector("#cart-popup-app");
    if (!el) return;
    var token = el.getAttribute("data-token");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: vueFilters,
        data: {
            cart: null,
            cartErrors: null,
            loading: false,
        },
        mounted: function () {},
        computed: {
            // isValid: function() {
            //     return this.shippingMethod && this.country && this.totalPrice > 0;
            // }
        },
        methods: {
            loadCart: async function (showLoader) {
                if (showLoader) this.loading = true;
                var result = await getCustomCart();
                this.cart = result.data.cart;
                updateCount(this.cart);
                if (showLoader) this.loading = false;
            },
            onChangeQuantity: async function (line, event) {
                if (event.target.value == "") return;

                var qty = parseInt(event.target.value);
                await this.innerSetQuantity(line, qty);
            },
            innerSetQuantity: async function (line, count) {
                line.qty = count;

                if (line.qty > 0) {
                    this.cart.itemTotal = null;
                    this.cart.itemSubtotal = null;
                    this.cart = deepClone(this.cart);
                    await setQuantity(token, line.id, line.qty);
                    this.loadCart(false);
                } else {
                    this.removeItem(line);
                }
            },
            setQuantity: async function (line, count) {
                var qty = parseInt(line.qty) + count;

                await this.innerSetQuantity(line, qty);
            },
            onClose: function () {
                closeCartPopup();
            },
            addToCart: async function (item, count, extras, metadata, remark, birthList) {
                this.loading = true;
                await addToCart(token, item, count, extras, metadata, remark, birthList);
                await this.loadCart(false);
                this.loading = false;
            },
            removeItem: async function (item) {
                var i = this.cart.lineItems.indexOf(item);
                this.cart.lineItems.splice(i, 1);
                this.cart.itemSubtotal = null;
                this.cart = deepClone(this.cart);
                var result = await removeItem(token, item);
                this.loadCart(false);
            },
        },
        watch: {},
    });

    window.cart = app;
}

window.addEventListener("scroll", () => (scrollY = getScrollY()));

window.addEventListener("resize", sizeCart);

window.openCartPopup = function (e) {
    if(e && !document.body.classList.contains('is-checkout')) e.preventDefault();
    if (!cartIsOpen) {
        window.cart.$el.classList.add("is-visible");
        window.cart.loadCart(true); // Load cart as soon as it's available
        cartIsOpen = true;
        sizeCart();
    }
};

function closeCartPopup() {
    if (cartIsOpen) {
        window.cart.$el.classList.remove("is-visible");
        cartIsOpen = false;
    }
}

function sizeCart() {
    if (cartIsOpen) {
        const cart = document.querySelector("#cart-popup-app");
        const cartIcon = document.querySelector(".navigation-shop--icon .cart-hover");
        const bounds = cartIcon.getBoundingClientRect();
        const coords = {
            top: isTablet() ? 0 : bounds.top + bounds.height + scrollY + cartOffset.top,
            left: isTablet()
                ? 0
                : -1 * (document.documentElement.clientWidth - bounds.right - cartOffset.right),
        };

        cart.style.setProperty("transform", `translate(${coords.left}px, ${coords.top}px)`);
    }
}

function initCartTriggers() {
    // Hover is added like this becuase if you hover purely with css the modal won't close whenever you press the close button (as you are still hovering over the cart itself)
    cartHovers.forEach((cartHover) => cartHover.addEventListener("click", openCartPopup));
}

function getScrollY() {
    return window.scrollY || window.pageYOffset;
}

function getScrollX() {
    return window.scrollX || window.pageXOffset;
}

function isTablet() {
    return document.documentElement.clientWidth < 900;
}

export default function init() {
    initCartTriggers();
    initCartApp();
}
